import "./DownloadPdfComponent.scss";
import "../../styles/index.scss";
import PropTypes from "prop-types";
/**
 * @function DownloadPdfComponent link for dowload PDf of category
 * @param info information that arrives procedurally provided
 * @returns {JSX.Element}
*/
const DownloadPdfComponent = ( { CategoryName, classBtn, isOutName, actionBtn, pdf } ) => {
    return (
        <div className="DownloadPdfComponent">
            <button onClick={ actionBtn } type="button" className={ `btn btn-${ classBtn } btn-icon DownloadPdfComponent__Button` }>
                <span> { pdf === true ? "Download PDF" : "Download"}{ !isOutName ? CategoryName : null }</span>
                <span className="material-icons-outlined" aria-hidden="true">file_download</span>
            </button>
            { isOutName ? <div className="DownloadPdfComponent__CategoryName">{ CategoryName }</div> : null }
        </div>

    );
};

DownloadPdfComponent.propTypes = {
    CategoryName: PropTypes.string.isRequired,
    classBtn: PropTypes.string,
    isOutName: PropTypes.bool,
    pdf: PropTypes.bool
};

DownloadPdfComponent.defaultProps = {
    CategoryName: "",
    classBtn: "primary",
    isOutName: false,
    pdf: true
};

export default DownloadPdfComponent;